import React from 'react'

import Chart from 'react-google-charts'
import classNames from "classnames/bind"

import styles from './timeline.module.scss';

const cx = classNames.bind(styles)

export const Timeline = () => {

    // Get today's date for current job
    const date = new Date();
    const masoniteJob = {
        day: date.getDate(),
        month: date.getMonth() + 1,
        year: date.getFullYear()
    }

    return (
        <div className={cx(['timeline-wrapper', "animate__animated", "animate__fadeIn"])}>
            <h2>Web Development History</h2>
            <Chart
                width={'100%'}
                height={'310px'}
                chartType="Timeline"
                loader={<div>Loading Chart</div>}
                data={[
                    [
                        { type: 'string', id: 'President' },
                        { type: 'string', id: 'dummy bar label' },
                        { type: 'string', role: 'tooltip' },
                        { type: 'date', id: 'Start' },
                        { type: 'date', id: 'End' },
                    ],
                    ['Sessions College of Professional Design', 'Student', null, new Date(2010, 8, 1), new Date(2012, 5, 1),],
                    ['Freelance', 'Web Developer', null, new Date(2011, 4, 1), new Date(2012, 5, 1)],
                    ['Ht Group', 'Web Developer', null, new Date(2012, 5, 1), new Date(2012, 8, 1)],
                    ['onXMaps', 'Lead Full Stack Developer', null, new Date(2012, 12, 1), new Date(2016, 4, 15)],
                    ['Acclaris', 'Front End Developer', null, new Date(2016, 6, 1), new Date(2018, 5, 1)],
                    ['Masonite International', 'Lead Full Stack Developer & Scrum Master', null, new Date(2018, 5, 1), new Date(masoniteJob.year, masoniteJob.month, masoniteJob.day)]
                ]}
                options={{
                    allowHtml: true,
                    timeline: {
                        rowLabelStyle: {fontSize: 14, color: '#603913' },
                        barLabelStyle: { fontSize: 12 },
                        dummyBarLabelStyle: { fontName: 'Garamond', fontSize: 14}
                    }
                }}
                rootProps={{ 'data-testid': '10' }}
            />
        </div>
    )
}
